import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
//primeReact

import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
//components
import Input from "../../../../../../components/input/Input";
import NumberInput from "../../../../../../components/input/NumberInput";
import CalendarInput from "../../../../../../components/input/CalendarInput";
//imports

import Modal from "../../../../../../components/modal/Modal";
import { searchInfoConvertedValue } from "../../../../../../services/Parcel/searchInfoConvertedValue";
import { anticipate } from "../../../../../../utils/anticipate";
import { sendAnticipateParcels } from "../../../../../../services/Parcel/sendAnticipateParcels";
import { useParcelContext } from "./ParcelContext";

const ModalAnticipateInstallments = () => {
  const {
    control,
    handleSubmit: handleUpdateParcel,
    errors,
    setValue,
    reset
  } = useForm();

  const [isVisibleConfirm, setIsVisibleConfirm] = useState(false);
  const [isCalculateClicked, setIsCalculateClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [parcelsAnticipate, setParcelsAnticipate] = useState([]);

  const {
    idSale,
    itemsSelected,
    setItemsSelected,
    isModalVisibleAnticipateRegressive,
    setIsModalVisibleAnticipateRegressive,
    refetch,
  } = useParcelContext();

  const style = {
    width: window.innerWidth <= 992 ? "95vw" : "95vw",
  };

  function sendUpdate(data) {
    setLoading(true);
    setIsCalculateClicked(true);
    var result = {
      sale_id: idSale,
      action: "anticipate",
      regressive: data.amount,
    };
    let totalParcelValue = 0;
    setParcelsAnticipate();

    searchInfoConvertedValue(result)
      .then((dado) => {
        let parcelsAnticipate = { ...dado };
        let totalParcelValue = 0;
        for (const key in dado) {
          if (Object.hasOwnProperty.call(dado, key) && !isNaN(parseInt(key))) {
            const parcel = dado[key];
            const processedParcel = {
              ...parcel,
              amortization_system: dado["amortization_system"],
              total_installments: dado["total_installments"],
              number_financing_installments:
                dado["number_financing_installments"],
              financing_value: dado["financing_value"],
              date_first_installment: dado["date_first_installment"],
              idSale: idSale,
              payment_date: data.payment_date.toISOString().split("T")[0],
              change_month_anticipation: dado["change_month_anticipation"],
              late_fee: dado["late_fee"],
              late_interest: dado["late_interest"],
            };
            const newResult = anticipate(processedParcel);
            parcelsAnticipate[key].anticipate_value = newResult;
            const newValueDiscount =
              parcelsAnticipate[key].value - newResult <= 0
                ? 0
                : parcelsAnticipate[key].value - newResult;

            parcelsAnticipate[key].newValueDiscount = newValueDiscount;

            totalParcelValue += newResult;
          }
        }
        setValue(
          "value",
          totalParcelValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
        // Remover as propriedades específicas do objeto 'teste'
        delete parcelsAnticipate.amortization_system;
        delete parcelsAnticipate.change_month_anticipation;
        delete parcelsAnticipate.date_first_installment;
        delete parcelsAnticipate.financing_value;
        delete parcelsAnticipate.late_fee;
        delete parcelsAnticipate.late_interest;
        delete parcelsAnticipate.number_financing_installments;
        delete parcelsAnticipate.total_installments;
        setItemsSelected(Object.values(parcelsAnticipate));
      })
      .then(() => {
        setParcelsAnticipate(Object.values(parcelsAnticipate));
        setIsVisibleConfirm(true);
        setIsCalculateClicked(false);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erro ao buscar antecipação regressiva:", error);
      });
  }

  function sendAnticipate(data) {
    setIsModalVisibleAnticipateRegressive(false);

    const sendArray = itemsSelected.map((item) => {
      return {
        id: item.id,
        discount: item.newValueDiscount,
      };
    });
    const sendData = {
      installments: sendArray,
      date_billet: data.payment_date.toISOString().split("T")[0],
    };

    const loadingNotification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );

    //Executar Antecipação das Parcelas
    sendAnticipateParcels(sendData)
      .then((result) => {
        // Verificar se a antecipação foi bem-sucedida
        if (result.success) {
          // Exibir notificação de sucesso
          toast.update(loadingNotification, {
            render:
              "Parcelas antecipadas com sucesso! Aguarde as parcelas estão sendo atualizadas...",
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "success",
            isLoading: false,
          });

          // Atualizar a lista após a conclusão da antecipação (opcional)
          refetch().then(() => {
            // Após a atualização, exibir notificação de sucesso
            toast.update(loadingNotification, {
              render: "Parcelas Atualizadas",
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              type: "success",
              isLoading: false,
            });
          });
        } else {
          // Se houver um erro durante a antecipação de parcelas,
          // exibir uma notificação de erro
          toast.update(loadingNotification, {
            render: result.error,
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "error",
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        console.log(error)
        const errorMessage =
          error.message && error.message
            ? error.message
            : "Não foi possível fazer a ação.";
        toast.update(loadingNotification, {
          render: errorMessage,
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao antecipar parcelas:", error);
      });
    setItemsSelected([]);
    setIsModalVisibleAnticipateRegressive(false);
    reset();
  }
  return (
    <>
      <Modal
        dynamicTitle="Antecipar Parcelas Regressivas"
        id="modal_cad"
        onHide={() =>
          setIsModalVisibleAnticipateRegressive(
            !isModalVisibleAnticipateRegressive
          )
        }
        visible={isModalVisibleAnticipateRegressive}
        style={style}
      >
        <Divider align="left">
          <div className="inline-flex align-items-center">
            <i className="pi pi-user mr-2"></i>
            <b> Calcular Antecipação</b>
          </div>
        </Divider>
        <form onSubmit={handleUpdateParcel(sendUpdate)}>
          <div className="mb-2">
            <div className="my-2">
              <CalendarInput
                minDate={new Date()}
                type="textarea"
                className="p-inputtext-sm rounded-4"
                label="Data de Pagamento"
                onChange={(e) => {
                  setIsCalculateClicked(true);
                }}
                errors={errors}
                isRequired={true}
                control={control}
                name="payment_date"
                rows={4}
                cols={30}
              />
            </div>
            <div className="my-2">
              <NumberInput
                type="textarea"
                className="p-inputtext-sm rounded-4"
                label="Quantidade de Parcelas"
                onChange={(e) => {
                  setIsCalculateClicked(true);
                }}
                errors={errors}
                isRequired={true}
                control={control}
                name="amount"
              />
            </div>
            <div className="my-2 d-flex align-items-center">
              <div className="col-md-8">
                <Input
                  className="p-inputtext-sm rounded-4"
                  disabled={true}
                  disable={true}
                  suffix={""}
                  prefix={"R$"}
                  placeholder={"0"}
                  max={undefined}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  name={`value`}
                  control={control}
                  label="Valor Atualizado"
                  style={{ fontWeight: "bold" }}
                />
              </div>
              <div className="col-md-4 d-flex justify-content-end">
                <Button
                  rounded
                  label="Calcular"
                  icon="fa-solid fa-calculator"
                  type="submit"
                  loading={loading}
                  className="p-inputtext-sm ml-2 mt-4"
                />
              </div>
            </div>
          </div>
          <div className="text-center mt-3">
            <Button
              rounded
              disabled={isCalculateClicked}
              visible={isVisibleConfirm}
              label="Confirmar Antecipação"
              icon="fa-solid fa-calculator"
              className="p-inputtext-sm m-auto"
              onClick={handleUpdateParcel(sendAnticipate)}
            />
          </div>
        </form>
      </Modal>
    </>
  );
};

export default ModalAnticipateInstallments;
